import actionTypes from '../actiontypes';


export const updatePageState = payload => ({
  type: actionTypes.UPDATE_PAGE_STATE,
  payload
})

